export default function EFWasher(props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M24.5 4H7.5C6.67157 4 6 4.67157 6 5.5V26.5C6 27.3284 6.67157 28 7.5 28H24.5C25.3284 28 26 27.3284 26 26.5V5.5C26 4.67157 25.3284 4 24.5 4Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M6 10H26" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 7H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="22" cy="7" r="1" fill="currentColor" />
            <circle cx="16" cy="19" r="6.25" stroke="currentColor" strokeWidth="1.5" />
            <path
                d="M10 19V19C11.6639 17.7899 13.8937 17.7038 15.646 18.7821L16 19L16.354 19.2179C18.1063 20.2962 20.3361 20.2101 22 19V19"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
}
